<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <el-form :label-position="labelPosition" :rules="rules" label-width="150px" :model="form">
          <el-form-item label="期次名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入期次名称"></el-input>
          </el-form-item>
          <el-form-item label="培训类型" prop="train_category" class="all_width">
            <el-select v-model="form.train_category" filterable placeholder="请选择培训类型" >
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in trainCategoryArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训方式" prop="train_type" class="all_width">
            <el-select v-model="form.train_type" filterable placeholder="请选择培训方式" >
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in trainTypeArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期次分类" prop="category" class="all_width">
            <el-select v-model="form.category" filterable placeholder="请选择期次分类" @change="courseType">
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in categoryArr" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期次简介" prop="synopsis" class="">
            <textarea  v-model="form.synopsis" placeholder="请输入期次简介"></textarea>
          </el-form-item>
           <el-form-item label="课程类型" prop="course_type" class="all_width">
            <el-select v-model="form.course_type" filterable placeholder="请选择课程类型" disabled >
              <el-option :label="item.name" :value="item.id" v-for="(item,index) in courseTypeArr" :key="index"></el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="培训开始时间" prop="begin_time" class="all_width">
                <el-date-picker
                    v-model="form.begin_time"
                    type="date"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="培训结束时间" prop="end_time" class="all_width">
                <el-date-picker
                    v-model="form.end_time"
                    type="date"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="报名截止时间" prop="close_time" class="all_width">
                <el-date-picker
                    v-model="form.close_time"
                    type="datetime"
                    placeholder="选择日期时间（在开始时间之前）">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="直播次数" prop="live_num">
                <el-input v-model="form.live_num" placeholder="请输入直播次数"></el-input>
            </el-form-item>
            <el-form-item label="课程数" prop="course_num">
                <el-input v-model="form.course_num" placeholder="请输入课程数" disabled></el-input>
            </el-form-item>
            <el-form-item label="GYB课程数" prop="gyb_course_num" v-show="showGYB">
                <el-input v-model="form.gyb_course_num" placeholder="请输入GYB课程" disabled></el-input>
            </el-form-item>
            <el-form-item label="SYB课程数" prop="syb_course_num" v-show="showSYB">
                <el-input v-model="form.syb_course_num" placeholder="请输入SYB课程" disabled></el-input>
            </el-form-item>
            <el-form-item label="学习总时长" prop="total_duration">
                <el-input v-model="form.total_duration" placeholder="请输入学习总时长">
                    <template slot="append">分钟</template>
                </el-input>
            </el-form-item>
            <el-form-item label="报名上限" prop="enroll_num">
                <el-input v-model="form.enroll_num" placeholder="请输入报名上线"></el-input>
            </el-form-item>
            <el-form-item label="期次排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入期次排序"></el-input>
            </el-form-item>
            <el-form-item label="允许报名区域" prop="allow_province" class="location">
                <el-select v-model="form.allow_province" filterable placeholder="请选择省" @change="changeProvince">
                <el-option :label="item.name" :value="item.code" v-for="(item,index) in province" :key="index"></el-option>
                </el-select>
                <el-select v-model="form.allow_city" filterable placeholder="请选择市" @change="changeCity">
                <el-option :label="item.name" :value="item.code" v-for="(item,index) in citys" :key="index"></el-option>
                </el-select>
                <el-select v-model="form.allow_area" filterable placeholder="请选择区">
                <el-option :label="item.name" :value="item.code" v-for="(item,index) in areas" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="期次LOGO" prop="logo">
                <div class="organization_img"> 
                    <i class="el-icon-plus avatar-uploader-icon" v-show="!showLogo || form.logo === ''"></i>
                    <input type="file" name="" id="" @change="onChange($event)" >
                    <img :src="form.logo" v-show="showLogo && form.logo != ''" class="form_img">
                    <img src="../../assets/image/delete.png" v-show="showLogo && form.logo != ''" class="close_img" @click="deleteImg('logo')">
                </div>
                <p class="suggest">建议尺寸750*400</p>
            </el-form-item>
            <el-form-item label="客服电话" prop="service_telephone">
                <el-input v-model="form.service_telephone" placeholder="请输入客服电话"></el-input>
            </el-form-item>
            <el-form-item label="每节课学习必须达到" prop="duration_rate">
                <el-input v-model="form.duration_rate" placeholder="请输入每节课学习时长占总时长的比率" disabled="disabled">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="合格的课程占比" prop="course_rate">
                <el-input v-model="form.course_rate" placeholder="请输入合格课程占总课程的比率" disabled="disabled">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="期次介绍" >
                <div class="editor">
                <tinymce-editor v-model="form.introduce"
                    :disabled="disabled"
                    ref="editor">
                </tinymce-editor>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../../utils/utils'
import TinymceEditor from '../../components/tinymce'
export default {
  name:'addPeriod',
  components:{
      TinymceEditor
  },
  data(){
    return {
      rules:{
        name :[{required: true, message: '请输入期次名称', trigger: 'blur'}],
        train_category :[{required: true, message: '请输选择培训类型', trigger: 'blur'}],
        train_type :[{required: true, message: '请输选择培训方式', trigger: 'blur'}],
        category :[{required: true, message: '请选择期次分类', trigger: 'blur'}],
        synopsis :[{required: true, message: '请输入期次简介', trigger: 'blur'}],
        course_type :[{required: true, message: '请选择课程类型', trigger: 'blur'}],
        begin_time :[{required: true, message: '请选择开始时间', trigger: 'blur'}],
        end_time :[{required: true, message: '请选择结束时间', trigger: 'blur'}],
        close_time :[{required: true, message: '请选择报名截止时间', trigger: 'blur'}],
        service_telephone :[{required: true, message: '请输入客服电话', trigger: 'blur'}],
        enroll_num :[{required: true, message: '请输入报名上线', trigger: 'blur'}],
        live_num :[{required: true, message: '请输入直播次数', trigger: 'blur'}],
        course_num :[{required: true, message: '请输入课程数', trigger: 'blur'}],
        syb_course_num :[{required: true, message: '请输入SYB课程数', trigger: 'blur'}],
        gyb_course_num :[{required: true, message: '请输入GYB课程数', trigger: 'blur'}],
        total_duration :[{required: true, message: '请输入学习总时长', trigger: 'blur'}],
        sort :[{required: true, message: '请输入排序', trigger: 'blur'}],
        allow_province :[{required: true, message: '请选择省', trigger: 'blur'}],
        logo :[{required: true, message: '请上传logo', trigger: 'blur'}],
        duration_rate :[{required: true, message: '请输入学习时长百分比 ', trigger: 'blur'}],
        course_rate :[{required: true, message: '请输入学习课程及格百分比', trigger: 'blur'}],
      },
      labelPosition: 'right',
      form: {
        name: '',
        train_category: '',//培训类型 
        train_type:'',//培训方式
        category:'',//期次分类
        synopsis:'',//期次简介
        course_type:'',//课程类型
        begin_time:'',//开始时间
        end_time:'',//结束时间
        close_time:'',//报名截止时间
        service_telephone:'',//客服电话
        enroll_num:'',//报名上线
        live_num:'',//直播次数
        course_num:21,//课程数
        syb_course_num:16,//syb
        gyb_course_num:5,//gyb
        total_duration:'',//学习总时长
        sort:'',//排序
        allow_province:'',
        allow_city:'',
        allow_area:'',
        logo:'',
        introduce:'',//  期次介绍
        duration_rate:80,//学习时长百分比 
        course_rate:80,//学习课程及格百分比 
      },
      ossInfor:{},
      suffix:'',
      showLogo:false,
      disabled:false,
      citys:'',
      areas:'',
      showSYB:false,
      showGYB:false,
    }
  },
  created(){
    this.onloadInfor()
    this.province = JSON.parse(this.$store.state.province) || JSON.parse(localStorage.getItem('province'))
    this.trainTypeArr = JSON.parse(this.$store.state.train_type) || JSON.parse(localStorage.getItem('train_type'))
    this.categoryArr = JSON.parse(this.$store.state.period_category) || JSON.parse(localStorage.getItem('period_category'))
    this.courseTypeArr = JSON.parse(this.$store.state.course_type) || JSON.parse(localStorage.getItem('course_type'))
    this.trainCategoryArr = JSON.parse(this.$store.state.train_category) || JSON.parse(localStorage.getItem('train_category'))
  },
  mounted(){

  },
  methods:{

      //上传logo
    onChange(event){
      var _that = this;
      let OSS = require('ali-oss')
      let client = new OSS({
        region: _that.ossInfor.region,
        accessKeyId: _that.ossInfor.accessKeyId,
        accessKeySecret: _that.ossInfor.accessKeySecret,
        stsToken:_that.ossInfor.securityToken,
        bucket: _that.ossInfor.bucket
      });
      let filename
      var files = event.target.files[0];
      let name = files.name
      const isLt5M = files.size / 1024 / 1024 <= 5;
      if (!isLt5M) {
        _that.$message.error('图片大小不能超过 5MB!');
      }else{
        if (name != '') {
          _that.suffix = Utils.get_suffix(name)
          filename = Utils.calculate_object_name(name)
        }
        client.put (_that.ossInfor.fileDir+ filename,files,).then(function(result){
            _that.form.logo = result.url
            _that.showLogo = true
        }).catch(function(err){
          console.log(err)
        }) 
      }
    },
    onloadInfor(){
      let params = {
        type : 4,
      }
      this.$api.user.uploadSTS(params)
        .then(res=>{
          if(res.code === 0){
            this.ossInfor = res.result
          }
        }) 
    },
    deleteImg(){
      this.form.logo= ''
      if(this.form.logo){
          this.showLogo = true;
      }
    },

    //选择省
    changeProvince(){
      this.form.city = ''
      this.form.area = ''
      this.citys = []
      this.areas = []
      let params = {
        code: this.form.allow_province
      }
      this.$api.user.getCity(params)
        .then(res=>{
            if(res.code === 0){
              this.citys = res.result
            }
        }) 
    },
    changeCity(){
      this.form.area = ''
      this.areas = []
      let params = {
        code: this.form.allow_city
      }
      this.$api.user.getArea(params)
        .then(res=>{
            if(res.code === 0){
              this.areas = res.result
            }
        }) 
    },
    courseType(value){
      this.form.course_type = this.form.category
      if(value === 1){
        this.form.course_num = this.form.syb_course_num = 16
        this.form.gyb_course_num = 0
        this.showSYB = true
        this.showGYB = false
      }else if(value === 2){
        this.showSYB = false
        this.showGYB = true
        this.form.syb_course_num  = 0
        this.form.course_num = this.form.gyb_course_num = 5
      }else{
        this.showGYB = true
        this.showSYB = true
        this.form.gyb_course_num = 5
        this.form.syb_course_num = 16
        this.form.course_num = Number(this.form.syb_course_num) + Number(this.form.gyb_course_num) 
      }
    },
    onSubmit(){
      let params = {
        name: this.form.name,
        train_category: this.form.train_category,//培训类型 
        train_type:this.form.train_type,//培训方式
        category:this.form.category,//期次分类
        synopsis:this.form.synopsis,//期次简介
        course_type:this.form.course_type,//课程类型
        begin_time:this.form.begin_time,//开始时间
        end_time:this.form.end_time,//结束时间
        close_time:this.form.close_time,//报名截止时间
        service_telephone:this.form.service_telephone,//客服电话
        enroll_num:this.form.enroll_num,//报名上线
        live_num:this.form.live_num,//直播次数
        course_num:this.form.course_num,//课程数
        syb_course_num:this.form.syb_course_num,//syb
        gyb_course_num:this.form.gyb_course_num,//gyb
        total_duration:this.form.total_duration,//学习总时长
        sort:this.form.sort,//排序
        allow_province:this.form.allow_province,
        allow_city:this.form.allow_city,
        allow_area:this.form.allow_area,
        logo:this.form.logo,
        introduce:this.form.introduce,//  期次介绍
        duration_rate:this.form.duration_rate,//学习时长百分比 
        course_rate:this.form.course_rate,//学习课程及格百分比 
      }
      if(!this.form.name){
        this.$message.error('请输入期次名称')
      }else if(!this.form.train_category){
        this.$message.error('请选择培训类型')
      }else if(!this.form.train_type){
        this.$message.error('请选择培训方式')
      }else if(!this.form.category){
        this.$message.error('请选择期次类型')
      }else if(!this.form.synopsis){
        this.$message.error('请输入期次简介')
      }else if(!this.form.course_type){
        this.$message.error('请选择课程类型')
      }else if(!this.form.begin_time){
        this.$message.error('请选择开始时间')
      }else if(!this.form.end_time){
        this.$message.error('请选择结束时间')
      }else if(!this.form.close_time){
        this.$message.error('请选择报名截止时间')
      }else if(!this.form.service_telephone){
        this.$message.error('请输入客服电话')
      }else if(!this.form.enroll_num){
        this.$message.error('请输入报名上限')
      }else if(!this.form.live_num){
        this.$message.error('请输入直播次数')
      }else if(!this.form.course_num){
        this.$message.error('请输入课程数')
      }else if(!this.form.syb_course_num && this.showSYB){
        this.$message.error('请输入SYB课程数')
      }else if(!this.form.gyb_course_num && this.showGYB){
        this.$message.error('请输入GYB课程数')
      }else if(!this.form.total_duration){
        this.$message.error('请输入学习总时长')
      }else if(!this.form.sort){
        this.$message.error('请输入排序')
      }else if(!this.form.allow_province){
        this.$message.error('请选择报名地')
      }else if(!this.form.logo){
        this.$message.error('请上传LOGO')
      }else if(!this.form.duration_rate){
        this.$message.error('请输入学习时长百分比 ')
      }else if(!this.form.course_rate){
        this.$message.error('请输入学习课程及格百分比 ')
      }else{
        this.$api.user.addPeriod(params)
          .then(res=>{
              if(res.code === 0){
                this.$router.replace({
                  path:'/period/period'
                })
              }
          }) 
      }
    },
    //清空内容
    clear() {
      this.$refs.editor.clear()
    }
  },
   computed: {
      
  }
}
</script>>
<style lang="scss" scoped>
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/editRotation.scss';
  @import '../../assets/scss/addOrganization.scss';
  @import '../../assets/scss/period.scss';
</style>
